import type { Tick } from "../types";
import { HistoryLoader } from "../data/HistoryLoader";

// Historical tick sources for replay. Deriv pages FORWARD from `start` (≤5000 ticks/request).
export interface TickSource {
  before(symbol: string, end: number, count: number): Promise<Tick[]>;
  forward(symbol: string, start: number, maxEnd: number): Promise<Tick[]>;
}

export const DerivHistorySource: TickSource = {
  before: (symbol, end, count) => HistoryLoader.ticks(symbol, count, { end }),
  forward: (symbol, start, maxEnd) => HistoryLoader.ticks(symbol, 5000, { start, end: Math.min(maxEnd, start + 5000) }),
};

// Felacoo's own recorded ticks (felacoo_ticks) — used when Deriv has no data for the range.
export function backendSource(fetchTicks: (symbol: string, from: number, to: number, limit: number) => Promise<Tick[]>): TickSource {
  return {
    before: (symbol, end, count) => fetchTicks(symbol, end - count * 4, end - 1, count),
    forward: (symbol, start, maxEnd) => fetchTicks(symbol, start, Math.min(maxEnd, start + 5000), 5000),
  };
}

export function compositeSource(primary: TickSource, fallback: TickSource | null): TickSource {
  return {
    async before(s, e, c) {
      const a = await primary.before(s, e, c).catch(() => [] as Tick[]);
      return a.length || !fallback ? a : fallback.before(s, e, c).catch(() => [] as Tick[]);
    },
    async forward(s, st, me) {
      const a = await primary.forward(s, st, me).catch(() => [] as Tick[]);
      return a.length || !fallback ? a : fallback.forward(s, st, me).catch(() => [] as Tick[]);
    },
  };
}
